import * as React from 'react'

import { useCompaniesQuery } from 'hooks/api'
import { listedCompanies } from 'utils/listedCompany'

import { MultiAutocompleteSelect, type MultiAutocompleteSelectOption } from './MultiAutocompleteSelect'

interface SelectCompanyFieldProps {
  onChange: (value: string[]) => void
  defaultValue?: string[]
}

export const SelectCompanyField = ({ onChange, defaultValue = [] }: SelectCompanyFieldProps) => {
  const [value, setValue] = React.useState<string[]>(defaultValue)

  React.useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const { data: companiesData, isLoading } = useCompaniesQuery({ limit: 200 })

  const companies = React.useMemo(
    () => listedCompanies(companiesData),
    [companiesData],
  )

  const options: MultiAutocompleteSelectOption[] = React.useMemo(
    () => companies.map(c => ({ value: c.id, label: c.name, avatar: c.logo })),
    [companies],
  )

  const handleChange = (next: string[]) => {
    setValue(next)
    onChange(next)
  }

  return (
    <MultiAutocompleteSelect
      label="Company"
      options={options}
      value={value}
      onChange={handleChange}
      placeholder="Select companies"
      helperText={value.length === 0 ? 'Choose one or more companies' : undefined}
      loading={isLoading}
    />
  )
}
